import { StyleSheet, View } from "react-native";
import { appColors, cardShadow } from "../../constants/colors";

export default function ChartLayout({ children }) {
  return <View style={styles.card}>{children}</View>;
}

const styles = StyleSheet.create({
  card: {
    flex: 1,
    width: "90%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: appColors.cardBg,
    paddingHorizontal: 12,
    paddingVertical: 14,
    borderRadius: 16,
    borderWidth: 0.5,
    borderColor: appColors.border,
    ...cardShadow(),
  },
});
